import React from 'react';
import { Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { FontFamily, typographyScale, TypographyVariant } from 'common/theme';
import { colors } from 'common/theme';

const sizeMap = {
  xs: TypographyVariant.LabelSmall,
  s: TypographyVariant.BodySmall,
  m: TypographyVariant.BodyMedium,
  l: TypographyVariant.BodyLarge,
  xl: TypographyVariant.TitleMedium,
  xxl: TypographyVariant.TitleLarge,
  xxxl: TypographyVariant.HeadlineMedium,
  xxxxl: TypographyVariant.HeadlineLarge,
};

const colorMap = {
  primary: colors.system.text.primary,
  secondary: colors.system.text.secondary,
  subtle: colors.system.text.subtle,
  inverse: colors.system.text.inverse,
  error: colors.system.state.error,
  success: colors.palette.green500,
  brand: colors.system.brand.primary,
};

const fontFamilyMap = {
  regular: FontFamily.regular,
  bold: FontFamily.bold,
  extraBold: FontFamily.extraBold,
};

export const TextHot = ({
  size = 'm',
  lineHeight,
  bold = 'regular',
  color = 'primary',
  children,
  isLtr=false,
  sx,
  component = 'span',
  testID,
  ...props
}) => {
  const theme = useTheme();
  const variant = sizeMap[size] || sizeMap.m;
  const scaleValues = typographyScale[variant];

  return (
    <Typography
      testId={testID}
      component={component}
      {...props}
      sx={{
        fontFamily: fontFamilyMap[bold] || fontFamilyMap.regular,
        fontSize: scaleValues.fontSize,
        lineHeight: lineHeight ? typographyScale[sizeMap[lineHeight]]?.lineHeight : scaleValues.lineHeight,
        letterSpacing: scaleValues.letterSpacing || 0,
        color: colorMap[color] || colorMap.primary,
        direction: isLtr ? 'ltr' : 'rtl',
        ...sx,
      }}
    >
      {children}
    </Typography>
  );
};

export default TextHot;

